var _path, _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssignment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.65015 0.166992C9.06517 0.1671 9.46488 0.331336 9.76245 0.628906L13.5378 4.41309C13.8353 4.7029 13.9998 5.10253 13.9998 5.51758V14.2666C13.9998 15.1282 13.295 15.8339 12.4333 15.834H3.02515C2.16359 15.8339 1.46655 15.1282 1.46655 14.2666V1.7334C1.4667 0.871938 2.1715 0.167137 3.03296 0.166992H8.65015ZM9.08862 4.13184C9.08865 4.51287 9.39997 4.82418 9.78101 4.82422H12.8992L9.08862 1.01367V4.13184Z",
    fill: "#84849A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.34668,
    y: 5.65039,
    width: 4.70001,
    height: 0.783335,
    rx: 0.391668,
    fill: "#FBFBFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.34668,
    y: 10.3506,
    width: 8.61669,
    height: 0.783335,
    rx: 0.391668,
    fill: "#FBFBFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.34668,
    y: 8,
    width: 8.61669,
    height: 0.783335,
    rx: 0.391668,
    fill: "#FBFBFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3.34668,
    y: 12.7002,
    width: 8.61669,
    height: 0.783335,
    rx: 0.391668,
    fill: "#FBFBFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignment);
export default __webpack_public_path__ + "static/media/assignment.f89f106a.svg";
export { ForwardRef as ReactComponent };